export default __webpack_public_path__ + "static/media/boomsell2.1d5e3753.png";